<template>
  <v-dialog v-model="dialog" max-width="800px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <p-confirm text="Os registros já adicionados não serão deletados, tem certeza que deseja interromper o processo?" :dialog="dialogConfirmStop" @confirm="confirmStopProcess" @cancel="dialogConfirmStop = false"></p-confirm>

    <v-card>
      <v-card-title primary-title>
        <span class="headline">Inclusão de várias tarefas</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding: 0px">
        <v-form ref="form" @keyup.native.esc="close(400)">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <!-- // Usado o v-show pois por algum motivo o arquivos estava se perdendo quando estava com v-if -->
                <v-flex xs12 v-show="!showItems" class="pb-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        :href="`${basePath}templates/inserir_tarefas.xlsx`"
                        @click.stop
                        v-on="on"
                      >
                        Clique aqui
                      </a>
                    </template>
                    Baixar arquivo com modelo de preenchimento de tarefa
                  </v-tooltip>
                  para baixar o modelo de preenchimento das tarefas e selecione o mesmo já preenchido no campo "Arquivo" abaixo.
                </v-flex>
                <v-flex xs12 class="py-0">
                  <!-- <v-container grid-list-lg> -->
                  <v-text-field :disabled="showItems" readonly placeholder="Arquivo - Clique aqui para inserir o arquivos inserir_tarefas.xlsx" @click="clickFile" v-model="editedItem.file_name" prepend-icon="attach_file" hide-details
                  ></v-text-field>
                  <input type="file" style="display: none" ref="fileInput" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="selectFile">

                </v-flex>

                <v-flex xs12 sm6>
                  <v-autocomplete :disabled="showItems" id="many_task_team_id" no-data-text="Não possui registros" :label="translate('table.' + entity + '.field.team_id')" :filter="filterAutocomplete" clearable @click:clear="$nextTick(() => editedItem.team_id=null)" v-model="editedItem.team_id" :items="taskComplements.teams_user" item-text="id_text" item-value="id" hide-details></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete :disabled="showItems" id="many_task_client_id" no-data-text="Não possui registros" :label="translate('table.' + entity + '.field.client_id')"
                  clearable @click:clear="$nextTick(() => changeClientNull())" v-model="editedItem.client_id" :items="taskComplements.clients" item-text="id_text" item-value="id" :filter="filterAutocomplete" hide-details></v-autocomplete>
                </v-flex>
                <strong v-if="showItems">Confira os dados abaixo e pressione o botão "ADICIONAR" para incluir todos os registros.</strong>
                <v-flex xs12>
                  <v-data-table
                    v-if="showItems"
                    :no-data-text="'Não veio registros'"
                    rows-per-page-text="Registros por página"
                    :headers="headers"
                    :items="items"
                    :rows-per-page-items="[100,200,500,{'text':'Todos','value':-1}]"
                    class="elevation-1 datatable-dense"
                    style="word-break: break-all;">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.id_text }}</td>
                      <td>{{ moment(props.item.end).format('DD/MM/YYYY HH:mm') }}</td>
                      <td>{{ props.item.note }}</td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
        </v-form>

      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions v-if="progress['active']">
        <!-- <v-progress-linear v-if="progress['active']" :value="progress['begin']/items.length"></v-progress-linear> -->
        <v-progress-linear height="20" :color="progress['begin'] < items.length ? 'primary' : 'green'" :value="progress['begin']/items.length*100">
        <p class="text-xs-center">{{(progress['begin'] > items.length) ? items.length : progress['begin']}} de {{items.length}} {{progress['begin'] >= items.length ? ' - Concluido' : ''}}</p>
        </v-progress-linear>
        &nbsp;
        &nbsp;
        <v-progress-circular
          v-if="(progress['begin'] < items.length) && !processStoped"
          indeterminate
          color="primary"
        ></v-progress-circular>
        &nbsp;
        &nbsp;
        <v-spacer></v-spacer>
        <!-- // Caso o o processo tenha finalizado mostra um botão para sair ou Caso o usuário tenha parado o processo mostra um botão para voltar -->
        <v-btn v-if="(progress['begin'] >= items.length) || processStoped" color="primary darken-2"  class="mx-0" @click.native="close()">Sair</v-btn>
        <!-- // Caso o processo esteja executando mostra um botão para o usuário interromper o processo -->
        <v-btn v-else class="mx-0" @click.native="dialogConfirmStop = true">Interromper</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="showItems">
        <v-spacer></v-spacer>
        <v-btn class="mx-0" color="primary darken-2" @click.native="saveManyTasks()">Adicionar</v-btn>
        <v-btn class="mx-0" @click.native="returnSaveManyTask()">Voltar</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn class="mx-0" color="primary darken-2" @click.native="getManyTasks()">Simular</v-btn>
        <v-btn class="mx-0" @click.native="close()">Sair</v-btn>
      </v-card-actions>
    </v-card>
      

    </v-dialog>
</template>

<style scoped>
  .datatable-dense td {
    height: 20px;
  }
</style>

<script>
  /* eslint-disable */

  import PConfirm from './../shared/PConfirm'

  export default {
    name: 'PAddManyTasks',
    components: {PConfirm},
    data: () => ({
      basePath: process.env.API,
      dialog: false,
      entity: 'tasks',
      editedItem: {},
      file: null,
      defaultItem: {},
      taskComplements: {},
      items: [],
      showItems: false,
      dialogConfirmStop: false,
      // Variavel usada caso o usuário tenha interrompido o processo e com isso para de executar.
      processStoped: false,
      // Variavel usada para a barra de progresso
      progress: {begin: 0, active: false},
    }),
    mounted () {
      this.editedItem = {team_id: '', client_id: '', file_name: ''}
      this.defaultItem = {team_id: '', client_id: '', file_name: ''}
    },
    methods: {
      // saveManyTasks é uma função recursiva que serve para ir adicionando registros de 100 em 100 para mostra a barra de progresso
      saveManyTasks () {
        // Também se o usuário clicar para adicionar os registros precisa ter mais de um item
        if (this.items.length == 0) {
          this.$store.commit('snackbar/change_values', {
            text: 'Não existem registros validos nessa planilha. Favor selecionar outra!',
            color: 'warning',
            dialog: true
          })
          return
        }
        Object.assign(this.progress, {'active': true})
        this.processSaveManyTasks()
      },
      // o begin pega a posição que vai iniciar e o qtd a quantidade de geristros que vai pegar
      processSaveManyTasks (begin = 0, qtd = 50) {
        let values = {}
        // identifica se é a ultima vez que passa pelo loop
        let finished = (begin + qtd) >= this.items.length
        // Pega os resgistros de acordo com o que foi passado nos parametros
        Object.assign(values, {'team_id': this.editedItem['team_id'],'client_id': this.editedItem['client_id'],'data': this.items.slice(begin, begin + qtd)})
        this.$http.post(`api/add_many_tasks`, values).then(res => {
          Object.assign(this.progress, {'begin': begin + qtd})
          // quando o begin + qtd ultrapassa a quantidade de items manda um socket para recarregar os outros usuários e fecha
          // Ou se o usuário tiver interrompido o processo manda um socket para atualizar
          if (finished || this.processStoped) {
            // quando insere varios registros chama o emit de recarregar a pagina pra recarregar a pagina do proprio usuário
            for (let user in res.body[0].participants) {
              // Atualiza sem ser o kanban
              this.$socket.emit('generalEvent', {
                notBroadcast: true,
                responseEvent: 'reloadTasksAll',
                room: `tasks${res.body[0].participants[user]}`
              })
              // Atualiza o kanban
              this.$socket.emit('generalEvent', {
                notBroadcast: true,
                responseEvent: 'reloadAllStatusPage',
                room: `tasks${res.body[0].participants[user]}`
              })
            }
            // Caso processStoped esteja true para de executar os processos
          } else if (!this.processStoped) {
            // Passa os valores de forma recursiva para ir incrementando os valores
            this.processSaveManyTasks(begin + qtd, qtd)
          }
          
          this.$store.commit('snackbar/change_values', {
            text: `Registros ${begin} até ${begin + qtd}, foram adicionados com sucesso!`,
            color: 'success',
            dialog: true
          })
        }, err => {
          console.log(err)
          this.confirmStopProcess()
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros do arquivo. Favor verificar sua planilha!`,
            color: 'error',
            dialog: true
          })
        })
      },
      returnSaveManyTask () {
        this.showItems = false
        this.progress = {begin: 0, active: false}
      },
      getManyTasks () {
        // Caso não tenha arquivo selecionado pede o usuário pra inserir um arquivo
        if (!this.$refs.fileInput.files[0]) {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor inserir um arquivo!',
            color: 'warning',
            dialog: true
          })
          this.$refs.fileInput.click()
          return
        }
        this.$store.commit('loader/change_dialog', true)
        // Cria um formulário virtual para passar os dados para o back, pois se não não tem como passar o arquivo
        let formData = new FormData()
        formData.append('file', this.$refs.fileInput.files[0])
        this.$http.post(`api/get_tasks_from_xls`, formData).then(res => {
          this.showItems = true
          this.items = res.body
          this.$store.commit('loader/change_dialog', false)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros do arquivo. Favor verificar sua planilha!`,
            color: 'error',
            dialog: true
          })
        })
      },
      filterAutocomplete (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      close () {
        this.showItems = false
        this.dialog = false
        this.$refs.fileInput.value = null
        this.items = [],
        this.processStoped = false,
        this.progress = {begin: 0, active: false},
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
      },
      openAddManyTasks () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/complement_task`).then(res => {
          this.taskComplements = res.body
          this.dialog = true
          this.$store.commit('loader/change_dialog', false)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros de tarefas!`,
            color: 'error',
            dialog: true
          })
        })
      },
      clickFile () {
        this.$refs.fileInput.click()
      },
      selectFile (event) {
        const files = event.target.files
        if (files[0] !== undefined) {
          this.editedItem.file_name = files[0].name
        } else {
          this.editedItem.file_name = ''
        }
      },
      confirmStopProcess () {
        this.dialogConfirmStop = false
        this.processStoped = true
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text'},
          {text: this.translate('table.' + this.entity + '.field.end'), value: 'end'},
          {text: this.translate('table.' + this.entity + '.field.note'), value: 'note'}
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PAddManyTasks.vue